import { ReviewPaymentFormSubmitEvent } from '@arc/unified-payments-frontend/shared-payment';
import { createActionGroup, props } from '@ngrx/store';

export const PoaReviewPaymentComponentActions = createActionGroup({
  source: 'POA Review Payment Component',
  events: {
    'Review Payment Step Submitted': props<{
      event: ReviewPaymentFormSubmitEvent;
    }>(),
  },
});
